interface SubmitActionsProps {
  onPublish: () => void;
  onSaveDraft: () => void;
  onDiscard: () => void;
  submitting: boolean;
}

export default function SubmitActions({ onPublish, onSaveDraft, onDiscard, submitting }: SubmitActionsProps) {
  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-6 border-t border-zinc-800">
      <button
        type="button"
        onClick={onDiscard}
        disabled={submitting}
        className="flex items-center gap-2 px-5 py-3 text-zinc-400 hover:text-red-400 border border-zinc-700 hover:border-red-800 rounded-lg transition-all duration-200 text-sm cursor-pointer whitespace-nowrap disabled:opacity-50"
        style={{ fontFamily: 'Cinzel, serif' }}
      >
        <i className="ri-delete-bin-line"></i>
        Discard
      </button>

      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onSaveDraft}
          disabled={submitting}
          className="flex items-center gap-2 px-6 py-3 bg-zinc-800 hover:bg-zinc-700 text-zinc-200 border border-zinc-600 rounded-lg transition-all duration-200 text-sm font-medium cursor-pointer whitespace-nowrap disabled:opacity-50"
          style={{ fontFamily: 'Cinzel, serif' }}
        >
          {submitting ? (
            <i className="ri-loader-4-line animate-spin"></i>
          ) : (
            <i className="ri-save-line"></i>
          )}
          Save Draft
        </button>

        <button
          type="button"
          onClick={onPublish}
          disabled={submitting}
          className="flex items-center gap-2 px-8 py-3 bg-red-700 hover:bg-red-600 text-white rounded-lg transition-all duration-200 text-sm font-bold cursor-pointer whitespace-nowrap disabled:opacity-50 shadow-lg shadow-red-900/30"
          style={{ fontFamily: 'Cinzel, serif' }}
        >
          {submitting ? (
            <i className="ri-loader-4-line animate-spin"></i>
          ) : (
            <i className="ri-send-plane-fill"></i>
          )}
          Publish Story
        </button>
      </div>
    </div>
  );
}
